var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFondoAzul(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 615.41 381.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7391c8;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 476.7,
    y1: 229.99,
    x2: 390.93,
    y2: 417.69,
    gradientTransform: "translate(10.92 -69.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff6e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#faf3e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#cad0dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#a4b5d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#89a1cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#7995c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#7391c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 504.96,
    y1: 137.4,
    x2: 475.97,
    y2: 200.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 584.99,
    y1: 160,
    x2: 565.83,
    y2: 201.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 566.2,
    y1: 95.87,
    x2: 547.05,
    y2: 137.79,
    gradientTransform: "translate(10.92 -69.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff6e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#faf3e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#cad0dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#a4b5d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#89a1cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#7995c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#7391c8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 615.41,
    height: 381.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 444.74,
    cy: 254.79,
    r: 103.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 501.39,
    cy: 100.08,
    r: 34.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 586.34,
    cy: 111.91,
    r: 23.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 567.55,
    cy: 47.78,
    r: 23.04
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoAzul);
export default __webpack_public_path__ + "static/media/fondo-azul.a492e6a77ec601d52a76640c21b83447.svg";
export { ForwardRef as ReactComponent };